export default __webpack_public_path__ + "static/media/151-plan.11d87695.png";